import {defineStore} from "pinia";
import {SimplifiedUser} from "@t/user/SimplifiedUser.ts";
import {SimplifiedGroup} from "@t/user/SimplifiedGroup.ts";
import {ref, computed} from "vue";
import {injectEnv} from "@fd/Environment.ts";


export const useUserStore = defineStore('user', () => {

	const env = injectEnv();

	const allUsers = env.users();
	const allGroups = env.groups();

	const partyCache = new Map<number, string>();

	/**
	 * Find name of a user, user group or party
	 * @param id numeric ID or login
	 */
	async function findName(id: number|string|undefined|null):Promise<string> {
		if (id == null) return "";

		const au:SimplifiedUser[] = await allUsers;
		for (let u of au) {
			if ((typeof id === "string" && u.login === id) || (typeof id === "number" && u.id === id)) return u.name;
		}
		const ag:SimplifiedGroup[] = await allGroups;
		for (let g of ag) {
			if ((typeof id === "string" && g.login === id) || (typeof id === "number" && g.id === id)) return g.name;
		}
		let name = id.toString();
		if (typeof id === "number") {
			name = partyCache.get(id);
			if (typeof name !== "string") {
				const serverName = await env.parties([ id ]);
				if (Array.isArray(serverName) && serverName.length > 0) {
					name = serverName[0].name;
				} else name = id.toString();
				partyCache.set(id, name);
			}
		}
		return name;
	}

	return {
		findName, allUsers, allGroups
	}
});